<script>
import * as dayjs from "dayjs";
import {planyTerapiiService} from "@/services/planyTerapii.service";
import CelPlanuZdrowieniaEdit from "@/components/clients/CelPlanuZdrowieniaEdit.vue";

export default {
  name: "CelePlanowZdrowienia",
  components: {CelPlanuZdrowieniaEdit},
  props: ["plan_zdrowienia_id"],
  data() {
    return {
      cele: [],
      loading: false,
      edytowany: null,
      title_edycja_tworzenie: 'Nowy cel terapii',
      nowy_cel_dialog: false,
      headers: [
        { text: 'Nazwa', value: 'nazwa' },
        { text: 'Status', value: 'status' },
        { text: 'Opis', value: 'opis' },
        { text: 'Data utworzenia', value: 'dataUtworzenia' },
        { text: 'Data zakończenia/anulacji', value: 'dataZakoczeniaAnulacji' },
        { text: 'Akcje', value: 'id' },
      ],
    }
  },
  mounted() {
    this.getData()
  },
  methods: {
    getFormattedDate(val)
    {

      if(val) {
        let dj = dayjs(val)

        if (dj != null) {
          return dj.format("DD-MM-YYYY")
        } else {
          return ''
        }
      }
      return ''
    },
    getStatusDescription(status) {
      switch (status){
        case 0:
          return 'Planowany';
        case 1:
          return 'Realizowany';
        case 2:
          return 'Zrealizowany';
        case 3:
          return 'Anulowany';
      }
      return '';
    },
    dodajCel() {
      this.edytowany = null
      this.nowy_cel_dialog = true
    },
    getData() {
      this.loading = true
      planyTerapiiService.getPlanTerapiiCel(this.plan_zdrowienia_id).then((response) => {
        this.cele = response.data.result
        this.loading = false
      }).catch(() => {
        this.showError('Bład pobierania celów terapii')
        this.loading = false
      })
    },
    editCel(item) {
      this.edytowany = item
      this.nowy_cel_dialog = true
    },
    closeEdit() {
      this.nowy_cel_dialog = false
      this.edytowany = null
      this.getData()
    }
  }
}
</script>

<template>
  <v-container>
    <v-row>
      <v-col cols="12">
        <v-spacer></v-spacer>
        <v-btn color="primary" @click="dodajCel">Nowy cel terapii</v-btn>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
      <v-data-table
            :headers="headers"
            :items="cele"
            :loading="loading"
            class="elevation-1"
        >
          <template v-slot:item="props">
            <tr>
              <td>{{props.item.nazwa}}</td>
              <td>{{getStatusDescription(props.item.status)}}</td>
              <td>{{props.item.opis}}</td>
              <td>{{getFormattedDate(props.item.dataUtworzenia)}}</td>
              <td>{{getFormattedDate(props.item.dataZakoczeniaAnulacji)}}</td>
              <td><v-icon small class="mr-2" @click="editCel(props.item)" color="primary"  title="Sprawdz celu">fa-edit</v-icon></td>
            </tr>
          </template>
        </v-data-table>
      </v-col>
    </v-row>
    <v-row v-if="nowy_cel_dialog">
      <v-dialog v-model="nowy_cel_dialog" persistent max-width="720px">
        <v-card>
          <v-toolbar dark class="primary">
            <v-btn icon @click.native="nowy_cel_dialog = false" dark>
              <v-icon>fa-times</v-icon>
            </v-btn>
            <v-toolbar-title>{{title_edycja_tworzenie}}</v-toolbar-title>
          </v-toolbar>
          <v-card-text>
            <CelPlanuZdrowieniaEdit v-if="nowy_cel_dialog" :plan_zdrowienia_id="plan_zdrowienia_id" :edytowany_cel="edytowany" @close="closeEdit"></CelPlanuZdrowieniaEdit>
          </v-card-text>
        </v-card>
      </v-dialog>
    </v-row>
  </v-container>
</template>

<style scoped>

</style>